import React from "react";
import { Modal } from "react-bootstrap";
import crossIcon from "../../../images/svg/deleteIcon.svg";

export default function FullImage({ show, image, onHide, imageType }) {
  return (
    <Modal
      className="modal fade image-modal"
      contentClassName="bg-transparent border-0 shadow-none"
      dialogClassName="image-modal-dialog"
      show={show}
      onHide={onHide}
      centered
    >
      <Modal.Body className="border-0 p-0 bg-transparent">
        <div className="image-container w-100" role="document">
          <div className="position-relative">
            <img
              src={crossIcon}
              alt="Cross Icon"
              className={`cross-icon pointer `}
              onClick={() => onHide()}
            />
            {imageType === "image" ? (
              <img
                src={image}
                alt="Image"
                className="rounded"
                style={{
                  transition: "width 0.5s, height 0.5s",
                  width: "100%",
                  height: "auto",
                  maxHeight: "85vh",
                  objectFit: "contain",
                  display: "block",
                  background: "transparent",
                }}
                onClick={() => onHide()}
              />
            ) : (
              <video
                controls
                muted
                autoPlay
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "85vh",
                  objectFit: "contain",
                  borderRadius: "8px",
                  display: "block",
                  background: "transparent",
                }}
                width="385"
                height="400"
              >
                <source src={image} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
